import { ComeBackVerification } from "./ComeBackVerification";
import { EFROTPVerification } from "./EFRVerification";

export default ComeBackVerification;
export { EFROTPVerification };
